import { memo } from "react";
import { makeStyles } from "tss-react/mui";
import { MiPlaceholderIcon } from "@miplatform/components";
import { CONTACT_CARD_EDIT_MODES, CONTACT_TYPES } from "@miplatform/constants";
import { mdiAccount } from "@mdi/js";
import { Box } from "@mui/material";
import { MiContactCard } from "../../../../../../components/MiContactCard/MiContactCard";

export const CloseoutContacts = memo(({ home, onRefresh }) => {
  const { classes } = useStyles();

  return (
    <Box className={classes.root}>
      {home?.contacts?.length > 0 ? (
        home.contacts.map((contact) => (
          <MiContactCard
            key={`${contact.id}${contact.level}${contact.label}`}
            isPrimaryDisabled
            contact={contact}
            accountId={contact.accountId}
            referenceIds={home?.referenceIds}
            editMode={CONTACT_CARD_EDIT_MODES.CONTACT}
            onRefresh={onRefresh}
            defaultContactLevel={CONTACT_TYPES.HOMES}
          />
        ))
      ) : (
        <Box alignSelf="center" mt={4}>
          <MiPlaceholderIcon
            icon={mdiAccount}
            text="No Contacts Found"
            helperText="There are no contacts associated with this home."
          />
        </Box>
      )}
    </Box>
  );
});

const useStyles = makeStyles()((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(2),
  },
}));
